import { mkdir, rm, writeFile } from "node:fs/promises";
import path from "node:path";
import extractZipArchive from "extract-zip";

export async function ensureDir(dirPath: string): Promise<void> {
  await mkdir(dirPath, { recursive: true });
}

export async function resetDir(dirPath: string): Promise<void> {
  await rm(dirPath, { recursive: true, force: true });
  await mkdir(dirPath, { recursive: true });
}

export async function writeUtf8(
  filePath: string,
  content: string,
): Promise<void> {
  await ensureDir(path.dirname(filePath));
  await writeFile(filePath, content, "utf-8");
}

export async function extractZip(
  zipPath: string,
  targetDir: string,
): Promise<void> {
  await ensureDir(targetDir);

  try {
    await extractZipArchive(zipPath, { dir: targetDir });
  } catch (error) {
    const details = error instanceof Error ? error.message : String(error);
    throw new Error(`Failed to extract zip at "${zipPath}". ${details}`);
  }
}
